<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-unidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';

export default {
  name: 'ListadoUnidadMedida',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'DESCRIPCION',
          field: 'descripcion',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 350,
          maxWidth: 350,
        },
        {
          headerName: 'UNIDAD',
          field: 'unidad',
          filter: false,
          minWidth: 300,
        },
        {
          headerName: 'CODIGO UNIDAD',
          field: 'codigo_unidad',
          filter: false,
          minWidth: 300,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-unidad {
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
</style>
  